import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";

const state = {
  categories: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_CATEGORIES_BUSY: (state, payload) => {
    state.categories.isBusy = payload;
  },
  LOAD_CATEGORIES_SUCCESS: (state, payload) => {
    state.categories.data = payload.data;
    state.categories.error = null;
  },
  LOAD_CATEGORIES_FAIL: (state, payload) => {
    state.categories.data = null;
    state.categories.error = payload;
  }
};

const actions = {
  getCategories: ({ commit, rootState }, { projectId, filterValues }) => {
    commit('LOAD_CATEGORIES_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    let query = '';
    if (filterValues && Object.keys(filterValues).length > 0) {
      query = '?';
      Object.keys(filterValues).map((param, i) => {
        query += `${param}=${filterValues[param]}${i !== Object.keys(filterValues).length - 1 ? '&' : ''}`;
      });
    }

    Axios
      .get(`${API_HOST}/projects/${projectId}/queries/categories${query}`, config)
      .then(response => {
        commit('LOAD_CATEGORIES_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_CATEGORIES_FAIL', error)
      })
      .finally(() => commit('LOAD_CATEGORIES_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};